import React, { useCallback, /*useEffect, useState,*/ useMemo, useRef } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  DirectionsRenderer,
  GoogleMap, //Marker, MarkerF, 
  useJsApiLoader,
  Circle
} from '@react-google-maps/api';
//import { UserSubmitDataMarker } from '../UserSubmitDataMarker';
//import { MMMarker } from '../markers/MMMarkers';
import { UserMarker } from '../markers/UserMarker';
import { /*Paper, Stack, */Box, Typography, Alert } from "@mui/material";
//import { loadCareCenterData, remove_carecenters } from '../../features/CareCenterDataSlice';
import { /*search, getSearchByTerm, */getSearchByCoordinates, SearchState, setCenter, setZoom } from "../../features/searchSlice";
//import { useGetProfilesForPointQuery, useDeleteProfileMutation, useAddProfileMutation, useUpdateProfileMutation, isFetchBaseQueryError, isErrorWithMessage } from '../../features/profilesSlice';
//import { skipToken } from "@reduxjs/toolkit/query";
//import { CenterMapHome } from "../map/CenterMapHome";
import { CircularProgressCentered } from '../../app/components/sharedcomponents';
import { InstitutionMarker, InstitutionMarkers, ShowMarkerType } from "../markers/InstitutionMarkers"
//import { useGetProfilesPinDataQuery } from "../../features/profilesSlice"
import { Warriors } from "../markers/MMMarkers"
//import { useBikeRoute } from './BikeRouteHook'
//import DottedRoute from "./DottedRoute";
import { condition } from "../..";
import { canDrawCircle, MapCircle, useAgentData } from "./MapCircle";

export const mapLibs: any[] = ['maps', 'places']

export const Map: React.FC<{ authStatus: any, profile: any }> = ({ authStatus, profile }) => {
  const { isLoaded } = useJsApiLoader({ id: 'google-map-script', googleMapsApiKey: "AIzaSyDvqapzpG_NMGMUv9Nj9IJnLNasbt_XzR8", libraries: mapLibs })// ['maps', 'places'] });
  const center = useSelector((state: any) => state.search.center);
  if (!isLoaded) {
    return (<><CircularProgressCentered /></>)
  }
  return (
    <>
      <MapLoaded center={{ lat: center?.lat ?? 34.746483, lng: center?.lng ?? -92.289597 }} authStatus={authStatus} profile={profile} />
    </>
  )
}

export const MapLoaded: React.FC<{ center: any, authStatus: any, profile: any }> = ({ center, authStatus, profile }) => {
  //   const mapRef = useRef<google.maps.Map | null>(null);
  const [map, setMap] = React.useState<google.maps.Map | null>(null)

  const searchState: SearchState = useSelector((state: any) => state.search);

  const dispatch = useDispatch();

  const filter = useSelector(useMemo(() => (state: any) => state.filter, []), shallowEqual)

  const containerStyle = {
    width: '100%',
    height: '100%'
  };

  const onLoad = React.useCallback(function callback(map: google.maps.Map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!    
    //dispatch(loadData({ type: "carecenters", center: searchState.center }));
    setMap(map)
    map.setOptions({ motionTrackingControl: false } as any)
    //const bounds = new window.google.maps.LatLngBounds(center);

  }, [])

  /*const onDragEnd = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!    
    //dispatch(loadData({ type: "carecenters", center: searchState.center }));
    //setMap(map)
    //const bounds = new window.google.maps.LatLngBounds(center);
    console.log(map)
    //dispatch(setCenter({ lat: event.latLng.lat(), lng: event.latLng.lng() }))
  }, [])*/

  function onDragEnd() {
    //setZoom(map.getZoom())
    if (map) {
      const center = map.getCenter();
      if (center) {
        const centerLat = center.lat();
        const centerLng = center.lng();
        dispatch(setCenter({ lat: centerLat, lng: centerLng }))
      }
    }
  }

  const zoomTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onZoomChanged = useCallback(() => {
    if (map) {
      if (zoomTimerRef.current) clearTimeout(zoomTimerRef.current);
      zoomTimerRef.current = setTimeout(() => {
        const zoom = map.getZoom();
        if (zoom) {
          dispatch(setZoom(zoom))
        }
      }, 150);
    }
  }, [map, dispatch]);

  const agentData = useAgentData();

  if (!center) {
    return (<>'no Center'</>)//null
  }
  const pages = condition === 'Multiple Myeloma'
  return (
    <Box
      component="div"
      sx={{
        position: { sm: 'absolute', md: 'static' },
        top: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        //backgroundColor: 'red'
      }}
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={searchState.zoom}
        onLoad={onLoad}
        onDragEnd={onDragEnd}
        onZoomChanged={onZoomChanged}
        //onClick={onClick}
        options={{
          streetViewControl: false,
          fullscreenControl: false,
          mapTypeControl: false,
          zoomControl: false,
          rotateControl: false,
          panControl: false,
          scaleControl: false,
          minZoom: 3,
          mapId: 'b5fcf45ccbb2b48',
          gestureHandling: "greedy"
        }}      >
        {(map && canDrawCircle(agentData)) && <MapCircle map={map} />}
        {/* {(false && !filter.showCareCenters && !filter.showWarriors) && <UserSubmitDataMarker />} */}
        {(filter.showCareCenters || agentData/*?.institutionPins*/) && <InstitutionMarkers agentData={agentData} />}
        {(filter.showWarriors || agentData/*?.userPins*/) && <Warriors />}
        {(authStatus === 'authenticated' && profile?.is_completed) && <UserMarker />}

        {/* Wheeling for Healing bike route removed */}


      </GoogleMap>

    </Box>)

}
// {( false && !filter.showCareCenters && !filter.showWarriors) && <UserSubmitDataMarker />}
// {(filter.showCareCenters) && <InstitutionMarkers zoom={searchState.zoom}/>}
// {( filter.showWarriors) && <Warriors center={center} zoom={searchState.zoom}/>}
const MemoizedMapLoaded = React.memo(MapLoaded, shallowEqual);
//export const MapLoadedMemoized = React.memo(MapLoaded)
//<MarkerF position={center} animation={window.google.maps.Animation.BOUNCE} />

